import React, { Fragment } from 'react';
import _ from 'lodash';
import { Accordion } from 'core/controls';
import { TranslateContext } from 'core/translate';
import ScrollTop from '../../common/ScrollTop';
import DriveTypeOptionGroup from '../../common/options/DriveTypeOptionGroup';
import SimpleOptionGroup from '../../common/options/SimpleOptionGroup';
import BodyTypeOptionGroup from '../../common/options/BodyTypeOptionGroup';
import MotorizationOptionGroup from '../../common/options/MotorizationOptionGroup';
import DimensionsRoute from '../dimensions/DimensionsRoute';

const ConfigWithoutFiltering = props => {
  const {
    engines,
    driveTypes,
    bodyTypes,
    motorizations,
    features,
    featureGroup,
    disclaimer,
    onChange,
    onDetails
  } = props;

  return (
    <ScrollTop>
      <Accordion>
        <TranslateContext.Consumer>
          {translate => (
            <Fragment>
              <MotorizationOptionGroup
                options={motorizations}
                onChange={option => onChange('driveType', option)}
              />
              <BodyTypeOptionGroup
                options={bodyTypes}
                disclaimer={disclaimer}
                features={features}
                featureGroup={featureGroup}
                onChange={option => onChange('bodyTypeId', option)}
              />
              <DriveTypeOptionGroup
                options={driveTypes}
                disclaimer={disclaimer}
                onChange={option => onChange('driveType', option)}
              />
              <SimpleOptionGroup
                header={translate('component.common.select.engine')}
                options={_.sortBy(engines, ['invoice'])}
                disableSingleOption={true}
                hideSingleCount={true}
                hidePrice={true}
                analyticsKey={translate('component.common.select.engine')}
                id="configuration-engines"
                onChange={option => onChange('engine', option)}
                onDetails={onDetails}
              />
            </Fragment>
          )}
        </TranslateContext.Consumer>
      </Accordion>
      <DimensionsRoute features={features} bodyTypes={bodyTypes} />
    </ScrollTop>
  );
};

export default ConfigWithoutFiltering;
